module.exports = __webpack_public_path__ + "img/testimonialpanel2.bc346764.jpg";